import React from 'react';
import { Container } from './styles';

const LogosRow: React.FC = () => (
  <Container>
    <img src={`img/logo-allya.svg`} alt="Allya" />
  </Container>
);

export default LogosRow;
